/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M20.831 14.156c-4.461 1.63-9.352-.6-11.068-5.06a8.76 8.76 0 0 1 0-5.917c.171-.429-.086-.943-.515-1.115a.733.733 0 0 0-.6 0C3.413 4.037.667 9.954 2.64 15.271c1.974 5.317 7.894 8.062 13.214 6.09a10.184 10.184 0 0 0 6.092-6.09c.171-.429-.086-.943-.515-1.115h-.6Z"
})), "0 0 24 24", "Moon");